/**
 * @file Album photo filter actions.
 */

export const UPDATE_FILTER = 'album-photo-filter/UPDATE_FILTER';
export const TOGGLE_UPLOADED_BY = 'album-photo-filter/TOGGLE_UPLOADED_BY';
export const TOGGLE_SORT_BY_SHOOT_TIME =
  'album-photo-filter/TOGGLE_SORT_BY_SHOOT_TIME';
export const RESET_FILTER = 'album-photo-filter/RESET_FILTER';

export const albumPhotosFilterUpdate = ({ albumPhotoFilter, uploadedBy }) => {
  return { type: UPDATE_FILTER, albumPhotoFilter, uploadedBy };
};

export const albumPhotosToggleUploadedBy = uploaderId => {
  return { type: TOGGLE_UPLOADED_BY, uploaderId };
};

export const albumPhotosToggleSortByShootTime = () => {
  return { type: TOGGLE_SORT_BY_SHOOT_TIME };
};

export const albumPhotosFilterReset = albumId => {
  return { type: RESET_FILTER, albumId };
};
